import React from "react";

const AnswerCheckButton = ({ loading, onClick, buttonText }) => {
  return (
    <div className="d-flex flex-row-reverse bd-highlight foot-buttons">
      <div className="submitButton">
        <button
          type="button"
          onClick={onClick}
          className={
            loading
              ? "buttonQuiz gray-buttonQuiz"
              : "buttonQuiz green-buttonQuiz"
          }
          disabled={loading}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};
export default AnswerCheckButton;
